import config from 'config';

import { USER_ROLE } from 'constants/user';

export const getBackButtonLabel = (userRole: USER_ROLE): string => {
  const buttonLabel = 'Back';
  switch (userRole) {
    case USER_ROLE.RM:
      return `${buttonLabel} to RM portal`;
    case USER_ROLE.STUDENT:
      return `${buttonLabel} to student portal`;
    default:
      return buttonLabel;
  }
};

export const navigateToPortal = (userRole: USER_ROLE): void => {
  switch (userRole) {
    case USER_ROLE.STUDENT:
      window.open(config.STUDENT_PORTAL_URL, '_self');
      break;
    case USER_ROLE.RM:
      window.open(config.RM_PORTAL_URL, '_self');
      break;
    case USER_ROLE.ADMIN:
      window.open(config.AUTH_ADMIN_PORTAL_URL, '_self');
  }
};

export const getCommunityLinkUrl = (communityUrl: string) => `/community/${communityUrl}`;

export const getPostLinkUrl = (communityUrl: string, postId: number) =>
  `${getCommunityLinkUrl(communityUrl)}/post/${postId}`;

export const getCommentLinkUrl = (communityUrl: string, postId: number, commentId: number, replyId?: number) =>
  `${getPostLinkUrl(communityUrl, postId)}#comment-${commentId}${replyId !== undefined ? '-reply-' + replyId : ''}`;

export const isUrlHashCommentLink = (hash: string) => hash.match(/^#comment-(\d+)/);
export const isUrlHashReplyLink = (hash: string) => hash.match(/^#comment-(\d+)-reply-(\d+)$/);

export const getCommentIdFromHashUrl = (hash: string) =>
  isUrlHashCommentLink(hash) ? Number(hash.split('-')[1]) : undefined;
export const getReplyIdFromHashUrl = (hash: string) =>
  isUrlHashReplyLink(hash) ? Number(hash.split('-')[3]) : undefined;
